import React from 'react';

import MerchantSelect from '@components/operator/MerchantSelect';
import PurchaseOrderEdit from '@components/shared/purchaseOrders/PurchaseOrderEdit';
import { useOperatorPurchaseOrderService } from '@hooks/operator/purchase_orders/useOperatorPurchaseOrderService';
import { useOperatorSupplierService } from '@hooks/operator/suppliers/useOperatorSupplierService';
import { useOperatorProductService } from '@hooks/operator/products/useOperatorProductService';

function PurchaseOrderNewInner() {
  const purchaseOrderService = useOperatorPurchaseOrderService();
  const supplierService = useOperatorSupplierService();
  const productService = useOperatorProductService();

  return (
    <PurchaseOrderEdit
      service={purchaseOrderService}
      supplierService={supplierService}
      productService={productService}
      role="operator"
    />
  );
}

export default function OperatorPurchaseOrderNew() {
  // 新增模式：先選擇 merchant
  return (
    <MerchantSelect>
      <PurchaseOrderNewInner />
    </MerchantSelect>
  );
}
